<template>
    <div>
      <div class=" row mb-2" >
        <label class="col-sm-4 lh40 text-lr"><i
            v-if=" Data.data.c_priority==='S'"
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
        <div class="col-sm-7 " v-for="(item,index) in temp_list" :key="index">
          <el-input v-model="item.name" placeholder="请输入内容"></el-input>

          <el-date-picker @change="dealData(index)"
              v-model="item.value" value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <span style="margin-left: 5px">  <el-button type="text" @click="add_temp()">+</el-button>
         <el-button type="text" @click="min_temp(index)" v-if="temp_list.length>1">-</el-button></span>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "dateBox",
        props: [
            'Data'
        ],
        data() {
            return {
              value: this.Data.data.c_value,
              temp_list:[{'name':'',value:['','']}]

            }
        },
        created() {
        },

        methods: {
          dealData(index){
            var list={}
            list[this.templist[index].name]={'start':this.value[0],'end':this.value[1]}
            this.$get_function(this.Data,list)
          },
          min_temp(index){
            this.temp_list.splice(index,1)
          },
          add_temp(){
            this.temp_list.push({'name':'',value:['08:00','18:00']})
          },

        }
    }
</script>

<style scoped>

</style>